import secondaryComponents from "../../..";
import { useProducts } from "./useProductTable";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { PurchaseOrderImage } from "../../../../../assets/svgImages";
import { RoutedModal } from "../../../../common";
import { OtherDetails } from "../OtherDetails";

export const ProductTable = ({
  gRForm,
  setGRForm = () => {},
  ...validationParams
}) => {
  const { instance, isOtherDetails, setIsOtherDetails } = useProducts({
    gRForm,
    setGRForm,
    ...validationParams,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div className={`${globalStyles.tableWrapper} ${styles.gRFormTable}`}>
        {/* table section */}
        <secondaryComponents.TableHelper
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          classNames={`${styles.tableSection}`}
          hasAction={true}
        >
          <div className="py-5 text-center">
            <PurchaseOrderImage />
            <h4>Items from the PO Number you selected will appear here</h4>
          </div>
        </secondaryComponents.TableHelper>
      </div>

      <RoutedModal
        isActive={isOtherDetails !== null}
        closeModal={() => setIsOtherDetails(null)}
        width={650}
        headerTitle="Add Other Details"
        style={{ height: "auto" }}
      >
        <OtherDetails
          itemInfo={isOtherDetails}
          gRForm={gRForm}
          setGRForm={setGRForm}
          closeModal={() => setIsOtherDetails(null)}
        />
      </RoutedModal>
    </>
  );
};
